import React from "react";
import PropTypes from "prop-types";

const SpecialEdgeHelpContent = ({description, children}) => (
  <div className="sqft-edge-help-content">
    {description && (
      <>
        <p className="sqft-edge-help-content__description">{description}</p>
        <div className="sqft-edge-help-content__separator" />
      </>
    )}
    {children}
  </div>
);

SpecialEdgeHelpContent.propTypes = {
  description: PropTypes.node,
  children: PropTypes.node.isRequired,
};

export default SpecialEdgeHelpContent;
